import React, { Component } from "react";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import NumberFormat from "react-number-format";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../../utils/Loader";

// State
import { removeCartProduct, removeCartCoupon, removeCartDonation, updateCartQty, clearDeleteMsg, clearUpdateMsg } from "../../../store/actions/cart";

// Utils
import getInventory from '../../../utils/inventoryUtils.js';

// CSS
import "../../../css/cart-item.css";

// Util
import { removeFromCart as removeFromCartGA } from "../../../utils/google-analytics";

class CheckoutSideProducts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDeleteModal: false,
			deleteType: '', //Which thing are we deleting
			showUpdateModal: false,
			showCouponError: false,
			quantityError: false,
			item: null,
			updateQty: 0
		};
	}

	componentWillMount() {
		this.props.clearDeleteMsg();
		this.props.clearUpdateMsg();
	}

	handleItemDelete(item, type) {
		switch(type){
			case 'coupon':
				this.props.removeCartCoupon(item.id);
				break;
			case 'donation':
				this.props.removeCartDonation(item.id);
				break;
			case 'product': 
				// this.handleCouponAutoRemove(item);
				this.props.removeCartProduct(item.id);
				removeFromCartGA(item);
				break;
			default:
				break;
		}
	}

	handleItemUpdate(product) {
		if(!!product.charity){
			this.props.removeCartDonation(product.id)
		}
		if(this.checkInventoryQuantity(product)){
			// this.handleCouponAutoRemove(product);
			this.props.updateCartQty(product.id, this.state.updateQty);
		}
	}

	//REMOVES COUPON IF THE CART TOTAL WOULD BE LOWER THAN THE COUPON REQUIREMENT
	handleCouponAutoRemove(product){
		if(this.props.codes.length){
			const code = this.props.codes[0];
			const productTotalToLose = product.total - (product.price * this.state.updateQty);
			const cartTotal = this.props.cart.cart_summary.total_price;
			const couponMin = this.props.codes.length ? code.min_sale_amount : 0;
			const newTotal = cartTotal - productTotalToLose;
			if(newTotal < couponMin){
				this.handleItemDelete(code, 'coupon');
				this.setState({ showCouponError: true });
			}
		}
		else {
			this.setState({ showCouponError: false });
		}
	}

	handleQtyKeyPress(event, productId) {
		if (event.key === "Enter") {
			this.props.clearUpdateMsg();
			this.handleItemUpdate(productId);
		}
	}

	quantityChange(event) {
		this.setState({ updateQty: event.target.value });
	}

	closeAction() {
		this.setState({
			showDeleteModal: false,
			showUpdateModal: false,
			quantityError: false,
			item: null,
			updateQty: 0
		});
		this.props.clearDeleteMsg();
		this.props.clearUpdateMsg();
	}

	// Check if customer is increasing quantity past the inventory of the item
	checkInventoryQuantity(item){
		// 1) GET VALUES
		const inventory 		= getInventory(item, item.variant);
		const quantityEntered 	= parseInt(this.state.updateQty, 10);

		// 2.1) PRODUCT HAS NO INVENTORY SET (NULL)
		if(inventory === null || inventory === undefined)
			return this.hideQuantityTooltipError();

		// 2.2) PRODUCT HAS INVENTORY SET (>=0)
		if(quantityEntered <= inventory)
			return this.hideQuantityTooltipError();
		else 
			return this.showQuantityTooltipError();
	}

	showQuantityTooltipError(){
		this.setState({quantityError: true});
		return false;
	}
	hideQuantityTooltipError(){
		this.setState({quantityError: false})
		return true;
	}

	render() {
		const { items, codes, donation, paymentActive, deletedId, deleteSuccess, deleteError, couponDeleteError, donationDeleteError } = this.props;
		console.log(codes);
		return (
			<div>
				{/* PRODUCTS */}
				{items.map((product) => {
					return (
						<div key={product.id} className={"cart-summary-item side-summary-item" + (paymentActive ? " no-delete" : "")}>
							{!paymentActive && (
								<button
									className="delete-btn"
									ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
									onClick={() =>
										this.setState({
											showDeleteModal: true,
											deleteType: 'product',
											item: product
										})
									}
								>
									-
								</button>
							)}

							<div className="item-content">
								<div className="item-title">{product.title}</div>
								<div className="line-item variant-sku">
									{product.variant ? (
										<span className="line-title">
											{product.variant.title} - {product.variant.sku}
										</span>
									) : (
										<span className="line-title">{product.sku}</span>
									)}
								</div>
								<div className="line-item quantity-line">
									<span className="line-title">Quantity</span> : <span className="item-qty">{product.qty}</span>
								</div>
							</div>
							<div className="item-price-column">
								<div className="item-price">
									<NumberFormat value={product.top_tier_discounted === 1 ? product.top_tier_original * product.qty : product.total} style={product.top_tier_discounted === 1 ? {textDecoration: 'line-through'} : {}} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
								</div>
								{product.top_tier_discounted === 1 &&
								<div className="item-price">
									<NumberFormat value={product.total} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
								</div>
								}
								{!paymentActive && (
									<button
										className="add-qty-btn"
										ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
										onClick={() =>
											this.setState({
												showUpdateModal: true,
												item: product,
												updateQty: product.qty
											})
										}
									>
										Update
									</button>
								)}
							</div>
						</div>
					);
				})}

				{/* SALE CODES */}
				{codes.map((code, i) => {
					if(code.code_type === "general"){
						return (
							<div key={i} className={"cart-summary-item side-summary-item sale-code-item" + (paymentActive ? " no-delete" : "")} data-id="coupon-{{id}}">
								{!paymentActive && (
									<button
										className="delete-btn"
										ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
										onClick={() =>
											this.setState({
												showDeleteModal: true,
												deleteType: 'coupon',
												item: code
											})
										}
									>
										-
									</button>
								)}
								<div className="item-content">
									<div className="item-title">{code.code}</div>
									<div className="line-item">
										<span className="line-title">Coupon</span>
									</div>
								</div>
								<div className="item-price-column">
									<div className="item-price">{code.sale_type === "dollar" ? <NumberFormat value={code.value} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} /> : <NumberFormat value={code.value} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} suffix={"%"} />}</div>
								</div>
							</div>
						);
					} else {
						return (
							<div key={i} className={"cart-summary-item side-summary-item sale-code-item" + (paymentActive ? " no-delete" : "")} data-id="coupon-{{id}}">
								{!paymentActive && (
									<button
										className="delete-btn"
										ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
										onClick={() =>
											this.setState({
												showDeleteModal: true,
												deleteType: 'coupon',
												item: code
											})
										}
									>
										-
									</button>
								)}
								<div className="item-content">
									<div className="item-title">Coupon ({code.code})</div>
									<div className="line-item variant-sku">
										<span className="line-title">{code.message ? code.message : ''}</span>
									</div>
								</div>
								<div className="item-price-column">
									<div></div>
								</div>
							</div>
						)
					}
				})}

				{/* Coupon update error */}
				{
					this.state.showCouponError && !this.props.codes.length ? (
						<div className="error">You do not have enough items in your cart for this promo.<br/><br/>Please add more items and re-add the promo code.</div>)
					: <div></div>
				}

				{/* DONATION */}
				{!!donation && donation.map((donation, i) => {
					return (
						<div key={i} className={"cart-summary-item side-summary-item sale-code-item" + (paymentActive ? " no-delete" : "")} data-id="coupon-{{id}}">
							{!paymentActive && (
								<button
									className="delete-btn"
									ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
									onClick={() =>
										this.setState({
											showDeleteModal: true,
											deleteType: 'donation',
											item: donation
										})
									}
								>
									-
								</button>
							)}
							<div className="item-content">
								<div className="item-title">Donation</div>
								<div className="line-item variant-sku">
									<span className="line-title">{donation.charity}</span>
								</div>
							</div>
							<div className="item-price-column">
								<NumberFormat value={donation.amount} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
							</div>
						</div>
					)
				})}

				{/* DELETE ITEM MODAL */}
				{this.state.showDeleteModal && (
					<Modal
						title={"Delete Item"}
						buttons={[
							{
								type: Button,
								text: "Yes",

								// Either delete coupon or product
								action: this.handleItemDelete.bind(this, this.state.item, this.state.deleteType),

								// Disable when deletion is in process or an error occurs
								disabled: this.props.deleteInProcess || !isEmpty(couponDeleteError) || !isEmpty(deleteError) || !!deleteSuccess
							},
							{
								type: Button,
								text: "Close",
								action: this.closeAction.bind(this),
								disabled: this.props.deleteInProcess
							}
						]}
					>
						
						{this.props.deleteInProcess ? (
							<div className="pt1">
								<Loader />
							</div>
						) : // Errors
						(couponDeleteError || deleteError || donationDeleteError) && deletedId === this.state.item.id ? (
							<div className="error">{deleteError ? deleteError : donationDeleteError}</div>
						) : // Success or confirmation message
						deleteSuccess ? (
							<div className="success">{deleteSuccess}</div>
						) : (
							<div>Are you sure you want to remove {this.state.item.title} from your cart?</div>
						)}
					</Modal>
				)}

				{/* UPDATE ITEM MODAL */}
				{this.state.showUpdateModal && (
					<Modal
						title={"Update Item Quantity"}
						buttons={[
							{
								type: Button,
								text: "Ok",
								action: this.handleItemUpdate.bind(this, this.state.item),
								disabled: this.props.updateInProcess || this.props.updateSuccess
							},
							{
								type: Button,
								text: "Close",
								action: this.closeAction.bind(this),
								disabled: this.props.updateInProcess
							}
						]}
					>
						{this.props.updateInProcess ? (
							<div className="pt1">
								<Loader />
							</div>
						) : (
							<div>
								<div className="form-field">
									<label>{this.state.item.title} Quantity:</label>
									<input className="qty" ref={(tooltipParentName) => this.tooltipParentName = tooltipParentName } type="number" min="1" step="1" name="qty" placeholder="0" defaultValue={this.state.updateQty} onChange={this.quantityChange.bind(this)} onKeyPress={e => this.handleQtyKeyPress(e, this.state.item)} />
								</div>
								{this.state.quantityError && <div className="error">{`There is only ${getInventory(this.state.item, this.state.item.variant)} of this item currently in stock.`}</div>}
								{/* {this.state.quantityError && this.tooltipParentName &&
									<Tooltip parent={this.tooltipParentName} type={"dialog--error"} messageObjects={showQuantityError} closeAction={this.props.clearUpdateMsg} />
								} */}
								{this.props.updateSuccess && <div className="success">{this.props.updateSuccess}</div>}
							</div>

						)}
					</Modal>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		cart: state.cart,
		items: state.cart.items,
		codes: state.cart.codes,
		donation: state.cart.donation,
		paymentActive: state.checkout.paymentActive,
		deleteSuccess: state.cart.deleteSuccess,
		deleteError: state.cart.deleteError,
		couponDeleteError: state.cart.couponDeleteError,
		deletedId: state.cart.deletedId,
		deleteInProcess: state.cart.deleteInProcess,
		updateInProcess: state.cart.updateInProcess,
		updateSuccess: state.cart.updateSuccess,
		clearUpdateMsg: state.cart.clearUpdateMsg
	};
};

export default connect(mapStateToProps, { removeCartProduct, removeCartCoupon, removeCartDonation, updateCartQty, clearDeleteMsg, clearUpdateMsg })(CheckoutSideProducts);



// WEBPACK FOOTER //
// ./src/components/checkout/side-summary/CheckoutSideProducts.js